import { AfterViewInit, Component, Renderer2 } from '@angular/core';

interface YouTubeVideo {
  id: string;
  title: string;
  channelAvatar: string;
  channelName: string;
}

interface IgPost { permalink: string; }

@Component({
  selector: 'app-brand-highlights',
  templateUrl: './brand-highlights.component.html',
  styleUrls: ['./brand-highlights.component.scss']
})
export class BrandHighlightsComponent implements AfterViewInit {

  readonly youtubeVideos: YouTubeVideo[] = [
    { id: 'CoTMhHmnSQY', title: '大師兄 Thank You Very Much 感謝祭｜葉蒨文女神晨食「特製泡芙」', channelAvatar: 'https://unavatar.io/youtube/@TVB',         channelName: 'TVB (official)' },
    { id: 'SDSxd048aQ8', title: 'TVB《撮食著數特攻隊》推介：CHEZ CHOUX 西樹泡芙',                  channelAvatar: 'https://unavatar.io/youtube/@neigbuy6010', channelName: '鄰住買 Neigbuy' },
    { id: 'acbl11nMj5E', title: 'TVB《鄰住買好嘢至抵食特約》推介：西樹泡芙',                       channelAvatar: 'https://unavatar.io/youtube/@neigbuy6010', channelName: '鄰住買 Neigbuy' }
  ];

  readonly igPosts: IgPost[] = [
    { permalink: 'https://www.instagram.com/p/DXYPDrVj_JV/' },
    { permalink: 'https://www.instagram.com/reel/DHVhxiDhfvo/' },
    { permalink: 'https://www.instagram.com/p/DTCJN2OiLxI/' }
  ];

  igSlideConfig = {
    arrows: false,
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  };

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    if (!document.querySelector('script[data-instgrm]')) {
      const s = this.renderer.createElement('script') as HTMLScriptElement;
      s.async = true;
      s.src = 'https://www.instagram.com/embed.js';
      s.setAttribute('data-instgrm', 'true');
      this.renderer.appendChild(document.body, s);
    }
    setTimeout(() => {
      const w = window as any;
      if (w.instgrm && w.instgrm.Embeds) w.instgrm.Embeds.process();
    }, 800);
  }

  // hqdefault.jpg is 480x360 and exists for ~every video — unlike maxresdefault
  // which is missing for many older / lower-quality uploads.
  youtubeThumb(id: string): string {
    return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  }

  youtubeUrl(id: string): string {
    return `https://youtu.be/${id}`;
  }
}
